import { PartialTranslation } from '../translations';

export const am: PartialTranslation = {
  newChat: 'አዲስ ውይይት',
  search: 'ፈልግ',
  user: 'ተጠቃሚ',
  settings: 'ማዋቀሪያዎች',
  language: 'ቋንቋ',
  getHelp: 'እገዛ ወሰድ',
  viewAllPlans: 'ሁሉንም እቅዶች ተመልከት',
  learnMore: 'ተጨማሪ ተማር',
  logOut: 'ወጣ',
  chooseLanguage: 'ቋንቋ ምረጥ',
  chooseYourPreferredLanguage: 'የምትመርጠውን ቋንቋ ምረጥ',
  searchLanguages: 'ቋንቋዎች ፈልግ...',
  autoDetect: 'ራስ-ሰር ማወቅ',
  noLanguagesFound: 'ምንም ቋንቋዎች አልተገኙም',
  askAnything: 'ማንኛውንም ጠይቅ',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ግላዊ',
  freePlan: 'ነፃ እቅድ',
  current: 'አሁኑ',
  close: 'ዝጋ',
  archive: 'ማህደር',
  delete: 'ሰርዝ',
  confirmDelete: 'እርግጠኛ ነህ ይህን ውይይት መሰረዝ ትፈልጋለህ?',
  confirmArchive: 'እርግጠኛ ነህ ይህን ውይይት ማህደር ውስጥ ማስገባት ትፈልጋለህ?',
  deleteCannotUndo: 'ይህ ተግባር መለወጥ አይችልም።',
  archiveCanFind: 'ማህደር ውስጥ ካስገባህ በኋላ ከማህደር ዝርዝር ውስጥ ማግኘት ትችላለህ።',
  resources: 'ግብዓቶች',
  addResource: 'ግብዓት ጨምር',
  deleteResource: 'ግብዓት ሰርዝ',
  noMatchingResourcesFound: 'ተስማሚ ግብዓቶች አልተገኙም',
  noResourcesAvailable: 'ምንም ግብዓቶች አይገኙም',
  hideResources: 'ግብዓቶችን ደብቅ',
  showResources: 'ግብዓቶች አሳይ',
  typeMessage: 'መልእክት ጻፍ...',
  thinkingOptions: 'የአስተሳሰብ አማራጮች',
  deleteFile: 'ፋይል ሰርዝ',
  clearSelection: 'ምርጫ አጽዳ',
  addAttachment: 'አባሪ ጨምር',
  sendMessage: 'መልእክት ላክ',
  deepInsight: 'ጥልቅ ግንዛቤ · ወለል ትንተና',
  deepInsightDesc: 'ዋና ዋና ነጥቦች ፈጣን ግንዛቤ',
  deepExploration: 'ጥልቅ ማሰሳ · አጠቃላይ ትንተና',
  deepExplorationDesc: 'ባለብዙ ገፅታ ጥልቅ ምርምር',
  deepDeconstruction: 'ጥልቅ መበታተን · ስርዓተ ክርክር',
  deepDeconstructionDesc: 'ንብርብር በንብርብር እድገታዊ ትንተና',
  contractReview: 'ውል ግምገማ · ስጋት መለየት',
  contractReviewDesc: 'አንቀጾች ትንተና እና ተገዢነት ፍተሻ',
  textPolish: 'ጽሁፍ ማሻሻያ · ሙያዊ አገላለጽ',
  textPolishDesc: 'ቋንቋ ማሻሻያ እና ስርዓተ ሰንሰለት ማስተካከያ',
  legalDocuments: 'ህጋዊ ሰነዶች · መደበኛ ረቂቅ',
  legalDocumentsDesc: 'ሙያዊ ህጋዊ ሰነድ ጽሁፍ',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'ግባ',
  register: 'ተመዝገብ',
  welcomeBack: 'ወደ LawHelper እንኳን ደህና መጡ',
  loginSubtitle: 'የእርስዎ AI የህግ ምርምር ረዳት',
  continueWithGoogle: 'በGoogle ቀጥል',
  continueWithMicrosoft: 'በMicrosoft ቀጥል',
  continueWithWeChat: 'በWeChat ቀጥል',
  orContinueWith: 'ወይም ቀጥል በ',
  emailTab: 'ኢሜይል',
  phoneTab: 'ስልክ',
  emailPlaceholder: 'ኢሜይልዎን ያስገቡ',
  phonePlaceholder: 'ስልክ ቁጥር ያስገቡ',
  codePlaceholder: 'የ6 አሃዝ ኮድ ያስገቡ',
  sending: 'በመላክ ላይ...',
  verifying: 'በማረጋገጥ ላይ...',
  verify: 'አረጋግጥ',
  sendMagicLink: 'አስማታዊ ሊንክ ላክ',
  getVerificationCode: 'ኮድ ያግኙ',
  resendCode: 'ኮድ እንደገና ላክ',
  resendIn: 'እንደገና ላክ',
  magicLinkSent: 'አስማታዊ ሊንክ ወደ ኢሜይልዎ ተልኳል',
  magicLinkHint: 'ደህንነቱ የተጠበቀ ሊንክ ወደ ኢሜይልዎ እንልካለን',
  otpSent: 'የማረጋገጫ ኮድ ተልኳል',
  agreeToTerms: 'በመቀጠል እርስዎ ይስማማሉ',
  privacyPolicy: 'የግላዊነት ፖሊሲ',
  termsOfService: 'የአገልግሎት ውሎች',
  and: 'እና',
  privacyTitle: 'ግላዊነትዎ አስፈላጊ ነው',
  privacyIntro: 'ምርጥ ተሞክሮ ለመስጠት ኩኪዎችን እና ተመሳሳይ ቴክኖሎጂዎችን እንጠቀማለን።',
  essentialCookies: 'አስፈላጊ ኩኪዎች',
  essentialDesc: 'ድህረ ገጹ እንዲሰራ ያስፈልጋል',
  analyticsCookies: 'የትንታኔ ኩኪዎች',
  analyticsDesc: 'አገልግሎትን ለማሻሻል ይረዳል',
  marketingCookies: 'የግብይት ኩኪዎች',
  marketingDesc: 'ለግል ይዘት ይጠቅማል',
  acceptAll: 'ሁሉንም ተቀበል',
  essentialOnly: 'አስፈላጊ ብቻ',
  customize: 'አብጅ',
  savePreferences: 'ምርጫዎችን አስቀምጥ',
  back: 'ተመለስ',
  readPrivacyPolicy: 'የግላዊነት ፖሊሲያችንን ያንብቡ',
  cookiePolicy: 'የኩኪ ፖሊሲ',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI ግምገማ',
  aiDraft: 'AI ረቂቅ',
  smartAssistant: 'አብነት',

  // 知识库搜索
  enableKnowledgeSearch: 'ፍለጋ አንቃ',
  knowledgeSearchDesc: 'AI በሰነዶችዎ ውስጥ ይፈልጋል',
  clickToDisable: 'አሰናክል',
  clickToEnable: 'አንቃ',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'Quick Answer',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'Cancel',
  library: 'Library',
  filterAll: 'All',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'Thinking...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'General',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'About',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Smart Document Assistant',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Error',
  unknownError: 'Unknown error',
  file: 'File',
  loading: 'Loading...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI Analyze',
};
